module.exports = "../content/4f0b85f5b601a405bdc7b23aad6d2a47.ttf";